












import { defineComponent } from '@vue/composition-api'
import Carousel3d from '@/components/Carousel3d.vue'
export default defineComponent({
  components: {
    Carousel3d
  },
  props: {
    title: {
      type: String,
      required: true
    },
    display: { type: Number, default: 5 },
    keyword: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  setup(props, { emit }) {
    return {
      centerClick(index: number) {
        emit('itemClick', index)
      }
    }
  }
})
